var $ = require('js/sw-jquery/sw-jquery');


// selects or de-selects a specific model and updates the count
window.selectModel = function selectModel(){
  $('#check-all').attr('checked', false);
};


// selects all of the models and updates the count
window.checkAll = function checkAll(){
  var checkAllBox = $('#check-all');

  // loop through all of the check boxes
  $('.modelCheckbox').each(function (i, el) {

    // check the box if it should be checked and update the count
    if (checkAllBox.is(':checked') && !($(el).is(':checked'))) {
      $(el).attr('checked', true);
    }

    // un-check the box if it should be unchecked and reset the count
    else if (!checkAllBox.is(':checked') && $(el).is(':checked')) {
      $(el).attr('checked', false);
    }
  });
};

// displays a pop to confirm deactivation and collect comments
window.deactivate = function deactivate(){
  window.showDialog('deactivateModels', 'Deactivate Models', true, '700px', 'deactivateModels');
};

// deactivates the selected models
window.deactivateSubmit = function deactivateSubmit() {

  // collect model deactivation data
  var checkedModels = [];
  $('.modelCheckbox:checked').each(function () {
    checkedModels.push($(this).val());
  });
  var modelIds = checkedModels.join(',');
  var comment = $('#deactivateModelsComment').val();
  var deactivationTypeId = $('#deactivationType').attr('value');
  var copyrightOwner = $("#copyrightOwner").val();
  var copyrightContent = $("#copyrightContent").val();
  var sendDesignerEmailManually = $("#sendDesignerEmailManually:checked").length ? 1 : 0;

  var options = {
    deactivationTypeId : deactivationTypeId,
    modelIds : modelIds,
    comment : comment,
    copyrightOwner : copyrightOwner,
    copyrightContent : copyrightContent,
    sendDesignerEmailManually : sendDesignerEmailManually
  };

  // submit the data for model deactivation
  $.ajax({
    url: '/cs-portal/json/deactivate-models-and-products',
    data: options,
    type: 'POST',
    dataType: 'json',
    success: function(data) {
      if(data.count === 0) {
        window.alert('no models were deactivated');
      }
      else {
        var message = data.count + ' model(s) were deactivated';

        if (data.order_ids.length) {
          message = message + "\r\nThe following orders were affected: " + data.order_ids.join(', ');
        }
        window.alert(message);
      }
      // close the modal and clear the comments section
      $('#deactivateModels').dialog('close');
      $('#deactivateModelsComment').val('');

      // hide the deactivated models from the list
      $.each(checkedModels, function(index, modelId){
        $('#' + modelId).attr('style', 'display:none');
      });
    },
    error: function() {
      window.alert("Something went wrong.");
    }
  });
};

// displays a popup to confirm reactivation and collect comments
window.reactivateModels = function reactivateModels(){
  window.showDialog('reactivateModels', 'Reactivate Models', true, '700px', 'reactivateModels');
};

window.reactivateSubmit = function reactivateSubmit() {
  var checkedModels = [];
  $('.modelCheckbox:checked').each(function () {
    checkedModels.push($(this).val());
  });
  var modelIds = checkedModels.join(',');
  var comment = $('#reactivateModelsComment').val();

  var options = {
    modelIds : modelIds,
    comment : comment
  };

  // submit the data for model deactivation
  $.ajax({
    url: '/cs-portal/json/reactivate-models-and-products',
    data: options,
    type: 'POST',
    dataType: 'json',
    success: function(data) {
      if(data.count === 0) {
        window.alert('no models were deactivated');
      }
      else {
        window.alert(data.count + ' model(s) were reactivated');
      }
      // close the modal and clear the comments section
      $('#reactivateModels').dialog('close');
      $('#reactivateModelsComment').val('');

      // hide the deactivated models from the list
      $.each(checkedModels, function(index, modelId){
        $('#' + modelId).attr('style', 'display:none');
      });
    }
  });
};

window.deleteSubmit = function deleteSubmit() {
  var checkedModels = [];
  $('.modelCheckbox:checked').each(function () {
    checkedModels.push($(this).val());
  });
  var modelIds = checkedModels.join(',');

  var options = {
    modelIds : modelIds
  };

  // submit the data for model deactivation
  $.ajax({
    url: '/cs-portal/json/deactivation-confirm-delete-models-and-products',
    data: options,
    type: 'POST',
    dataType: 'json',
    success: function(data) {
      if(data.count === 0) {
        window.alert('no models were deleted');
      }
      else {
        window.alert(data.count + ' model(s) were deleted');
      }
      // close the modal and clear the comments section
      $('#deleteDeactivatedModels').dialog('close');

      // hide the deactivated models from the list
      $.each(checkedModels, function(index, modelId){
        $('#' + modelId).attr('style', 'display:none');
      });
    }
  });
};

// displays a popup to confirm that the user wants to delete the selected models
window.deleteDeactivatedModels = function deleteDeactivatedModels() {
  window.showDialog('deleteDeactivatedModels', 'Delete Models', true, '750px', 'deleteDeactivatedModels');
};
